import React, { useEffect, useState } from "react";
import "./Navbar.css";
import logo from "../Images/Logo.PNG";
import Typography from "@material-ui/core/Typography";
import { useAuth } from "../authContext"

import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import NavListDisplay from './NavItems';
 // Material ui
import {styled} from '@material-ui/core/styles'
import {useTheme,useMediaQuery} from '@material-ui/core'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Drawer from "./NavDrawer";

const LeftItem=styled('div')({
  width:'100%',
  display:'flex',
  alignItems:'center',
  justifyContent:'flex-start',
  flexDirection:'row'
})

const NavItems=styled('div')({
  display:'flex',
  alignItems:'center',
  justifyContent:'flex-end',
  flexDirection:'row'
})

const NavLogo=styled('div')({
  height:'30px',
    width:'50px'
})

export default function Navbar() {
    // const authenticated = useSelector(state => state.auth.jwt)
    // const data = useSelector(state => state.user.user)
    const theme=useTheme()
    const { currentUser } = useAuth();
    const [authenticated,setAuthenticated] = React.useState(false);
const [data,setData] = React.useState({});
useEffect(()=>{
if(currentUser){
  setAuthenticated(true);
  setData(currentUser);
}
},[currentUser])
    return (
      <>
        <AppBar elevation={0} position="static" style={{height:"60px",backgroundColor:'#46516d'}}>
          <Toolbar style={{width:'100%',minHeigth:'50px'}}>
            <LeftItem>
                <NavLogo>
              <NavLink to={"/"}>

              <img width='100%' height='100%' src={logo} className="logoimage" alt={"logo"}/>

              </NavLink>
                </NavLogo>
            </LeftItem>
            <NavItems>
              {/* NAV LINKS */}
              {
                useMediaQuery(theme.breakpoints.up('md'))?
                <NavListDisplay authenticated={authenticated} data={data}/>
                :
                <Drawer authenticated={authenticated} data={data}/>
              }
          {/* END NAV LINKS */}
            </NavItems>
          </Toolbar>
        </AppBar>
      </>
    );
}
